import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Tooltip } from '@material-ui/core'
import Icon from '../components/atoms/Icon'
import { viewDisabledWarningMessage } from './viewDisabledWarningMessage'

const useStyles = makeStyles((theme) => ({
  warningMarker: {
    position: 'absolute',
    top: '-10px',
    left: '-10px',
    backgroundColor: 'var(--color-warning-500)',
    fill: 'var(--color-danger-050)',
    color: 'var(--color-danger-050)',
    outlineStyle: 'solid',
    outlineColor: 'color-mix(in srgb, var(--color-warning-500) 90%, black)',
    outlineWidth: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'var(--border-radius-round)',
    minWidth: '30px',
    minHeight: '30px',
    boxShadow: theme.layout.shadow.normal,
    transition: 'background-color 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'color-mix(in srgb, var(--color-warning-500) 60%, white)',
      cursor: 'pointer'
    }
  },
  warningMarkerInside: {
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'var(--color-warning-500)',
    fill: 'var(--color-danger-050)',
    color: 'var(--color-danger-050)',
    outlineStyle: 'solid',
    outlineColor: 'color-mix(in srgb, var(--color-warning-500) 90%, black)',
    outlineWidth: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    minHeight: '20px',
    borderBottomRightRadius: theme.layout.radius.tight,
    boxShadow: theme.layout.shadow.normal,
    transition: 'background-color 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'color-mix(in srgb, var(--color-warning-500) 60%, white)',
      cursor: 'pointer'
    }
  },
  descriptionWrap: {
    '&.MuiTooltip-popper': {
      '& .MuiTooltip-tooltipPlacementTop': {
        minWidth: '30vw',
        backgroundColor: 'var(--theme-color-surface-d0)',
        color: 'var(--text-color-main)',
        border: 'var(--border-neutral-emphasis)',
        boxShadow: theme.layout.shadow.deep,
        lineHeight: '18px',
        fontSize: theme.typography.fontSizes.xl,
        padding: `${theme.layout.padding.thin} ${theme.layout.padding.thick}`
      },
      '& .MuiTooltip-tooltipPlacementBottom': {
        minWidth: '30vw',
        backgroundColor: 'var(--theme-color-surface-d0)',
        color: 'var(--text-color-main)',
        border: 'var(--border-neutral-emphasis)',
        boxShadow: theme.layout.shadow.deep,
        lineHeight: '18px',
        fontSize: theme.typography.fontSizes.xl,
        padding: `${theme.layout.padding.thin} ${theme.layout.padding.thick}`
      }
    }
  }
}))

function ViewEnablementWarning ({ isInWarning, viewOriginal, setViewOriginal, variant }) {
  const classes = useStyles()
  const size = variant === 'inside'
    ? '16px'
    : '22px'

  if (!isInWarning) {
    return null
  }

  return (
    <Tooltip
      classes={{
        popper: classes.descriptionWrap
      }}
      title={viewDisabledWarningMessage(viewOriginal)}
    >
      <div onClick={() => setViewOriginal(p => !p)} className={variant === 'inside' ? classes.warningMarkerInside : classes.warningMarker}>
        <Icon name='warning' customSize={size} style={{ marginTop: '-2px' }} />
      </div>
    </Tooltip>
  )
}

ViewEnablementWarning.propTypes = {
  isInWarning: PropTypes.bool,
  viewOriginal: PropTypes.bool,
  setViewOriginal: PropTypes.func,
  variant: PropTypes.oneOf(['over', 'inside'])
}

ViewEnablementWarning.defaultProps = {
  variant: 'inside'
}

export default ViewEnablementWarning
